<script>
  import { onMount } from 'svelte';
  import Modal from './RiderModal.svelte';
  import { nameSeperate, searchTable } from '../helper';
  import { categories, raceResultsStore as data, races } from '../stores'; 
  export let categoryId;
  export let participants;
  export let filteredList;
  
  let isOpenModal = false;
  const allRiderRaces = JSON.parse(JSON.stringify($data));
  let riderRaces;
  let riderId;


  function openModal(rider_id) { 
    riderId = rider_id;  
    let overallRaceRankArray = getOverallRaceRankArray(rider_id, allRiderRaces);
    riderRaces =  allRiderRaces.filter(item => item.pn === rider_id);
    riderRaces.forEach(rider => {
      rider['op'] = overallRaceRankArray.find(item => item.race_id === parseInt(rider.ri)).op; // add overall position
    })
    isOpenModal = true;
  }

  function closeModal() {
    isOpenModal = false;
  }
  
  function attachMedal(item, categoryId) {
    let medalColor = ["black", "#FFD700", "#C0C0C0", "#CD7F32"];
    let html = item;
    let rank = parseInt(item);

    if (categoryId != 0) {
      if (rank <= 3 && rank != 0) {
        html = '<svg width="30" height="30"><circle cx="15" cy="15" r="15" fill="'+ medalColor[rank] + '" /><text x="50%" y="50%" text-anchor="middle" fill="black" font-size="1.05rem" font-family="Arial" dy=".3em">' + rank +'</text></svg>';
      } else {
        html = '<svg width="30" height="30"><circle cx="15" cy="15" r="15" fill="black" /><text x="50%" y="50%" text-anchor="middle" fill="white" font-size="1.05rem" font-family="Arial" dy=".3em">' + rank +'</text></svg>';
      }
    } else {
      html = '<svg width="30" height="30"><circle cx="15" cy="15" r="15" fill="black" /><text x="50%" y="50%" text-anchor="middle" fill="white" font-size="1.05rem" font-family="Arial" dy=".3em">' + rank +'</text></svg>';
    }
    return html;
  }

  function convertTimeToNumber(time) {
    time = time.replace(/DNS|DQ|DNF/gi, "999999999999");
    time = time.replace(/:/g, "");
    return time;
  }

  function fixAllRanking(value, index, array) {
    value.r = index + 1;
    return value;
  }
/*
  if (categoryId != 0) {
    filteredList = riders.filter(item => item.ci == categoryId);
  } else {
    filteredList = JSON.parse(JSON.stringify(riders));
  }
*/
  filteredList = JSON.parse(JSON.stringify(participants));
  filteredList = filteredList.sort((a, b) => convertTimeToNumber(a.t) - convertTimeToNumber(b.t));
  filteredList = filteredList.map(fixAllRanking);

  function getOverallRaceRankArray(rider_id, allRaces) {
    let overallPositionArray = [];
    $races.forEach(race => {
      let raceData = allRaces.filter(item => parseInt(item.ri) === parseInt(race.id));
      let raceParticipants = JSON.parse(JSON.stringify(raceData));
      raceParticipants = raceParticipants.sort((a, b) => convertTimeToNumber(a.t) - convertTimeToNumber(b.t));
      let overallPosition = (raceParticipants.findIndex(x => x.pn === rider_id) + 1);
      overallPositionArray.push({'race_id': race.id, 'op': overallPosition});
    })
    return overallPositionArray;
  }
</script>


{#if categoryId != -1}
<div class="m-0 p-0">
  {#if filteredList.length > 10}
  <div style="background-color: #ADB5BE;">
    <input type="text" class="searchInput shadow-inset" id="search_{categoryId}" on:keyup={searchTable(this, categoryId)} placeholder="Search for names..">
  </div>
  {/if}
  <table id="table_{categoryId}" class="table table-hover align-middle" style="font-size: 0.75rem;">
    <thead style="background-color: #ADB5BE;">
      <tr>
        <th scope="col">RNK</th>
        <th class="name_style" scope="col">&nbsp;</th>
        <th scope="col">TIME</th>
        <th scope="col">PTS</th>        
      </tr>
    </thead>
     <tbody class="tbody_class">
      <div style="display: none;"></div>
      {#if filteredList.length > 0}
        {#each filteredList as rider}
          <tr>
            <th class="align-middle" scope="row">{@html attachMedal(rider.r, categoryId)}</th>
            <td class="align-middle">
              <div style="display:table;">
                <div class="col name_style" style="cursor:pointer;display:table-row;" on:click={openModal(rider.pn)}>
                  <div style="display:table-cell; vertical-align:middle;"><span class="bib">#{rider.pn}</span>&nbsp;&nbsp;&nbsp;</div>
                  <div style="display:table-cell;">
                    <div>{@html nameSeperate(rider.n, rider.ci)}</div>
                  </div>
                </div>
                  {#if categoryId == 0}
                  <div style="display:table-row;">
                     <div style="display:table-cell;"></div>
                     <div class="col text-start text-danger text-capitalize align-left" style="display:table-cell; padding:0;">{$categories.filter(item => item.id == rider.ci)[0].name}</div>
                  </div>
                  {/if}
                </div>
            </td>
            <td class="align-middle">{rider.t}</td>
            <td class="align-middle">{rider.p}</td>
          </tr>
        {/each}
      {:else}
        <tr><td colspan="5">No Riders.</td></tr>
      {/if}
    </tbody>
  </table>
</div>
{:else}
  <div>
    <table class="table">
      <thead>
        <tr>
          <td colspan="5">No Data Available.</td>
        </tr>
      </thead>
    </table>
  </div>
{/if}


<Modal riderId={riderId} riderRaces={riderRaces}  isOpenModal={isOpenModal} on:closeModal={closeModal} />


<style>
  .searchInput {
    /*background-image: url('../icon-search.svg');*/ /* Add a search icon to input */
    background-position: 10px 12px; /* Position the search icon */
    background-repeat: no-repeat; /* Do not repeat the icon image */
    width: 97%; /* Full-width */
    font-size: 16px; /* Increase font-size */
    padding: 10px 20px 10px 14px; /* Add some padding */
    border: 1px solid #868E96; /* Add a grey border */
    border-radius: 5px;
    margin: 12px auto; /* Add some space below the input */
    background-color: #F8F9FA;
  }

  
  .shadow-inset {
    /*
    box-shadow: 0px 1px 10px -3px rgba(0,0,0,0.83) inset;
    -webkit-box-shadow: 0px 1px 10px -3px rgba(0,0,0,0.83) inset;
    -moz-box-shadow: 0px 1px 10px -3px rgba(0,0,0,0.83) inset;
    */

    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.83) inset;
    -webkit-box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.83) inset;
    -moz-box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.83) inset;
  }
  

  table {
    margin-bottom: 0px;
    border-bottom: 2px solid #868E96;
  }

  thead {
    border:0px;
  }

  thead th {
    border : 0px;
  }

  thead tr {
    border: 0px;
  }

  tbody {
    border: 0px;
    background-color: #f8f8f8;
  }

  tbody td, tbody th {
    border: 0px;
  }
  
  span.bib {
    background-color: #fff;
    border: 2px solid #ccc;
    text-align: center;
    border-radius: 3px;
    padding: 5px 5px;
    font-weight:700;
    /*display: inline-block;*/
  }
  
  /* Reset some of the demo app styles that interfere. */
  :global(html) {
    height: auto;
    width: auto;
    position: static;
  }
  :global(#sapper),
  :global(body) {
    display: block;
    height: auto;
  }

  .name_style {
    text-transform: uppercase;
    text-align: left;
  }
</style>